import env from "@libs/util/environment";
export const BOOK_OFFER_CATEGORY = "book";
export const POINT_OFFER_CATEGORY = "points";

const mycom_real_orders = {
  bp_book: 17,
  bp_book_and_pack_bonus: 3873,
  bp_points_100: 18,
  bp_points_500: 19,
  bp_points_2500: 20,
};
const categories = [
  {
    pattern: "bp_book",
    name: BOOK_OFFER_CATEGORY,
  },
  {
    pattern: "bp_points",
    name: POINT_OFFER_CATEGORY,
  },
];
const getCategory = function(offer_name) {
  for (let i = 0, count = categories.length; i < count; i++) {
    if (offer_name.indexOf(categories[i].pattern) > -1) {
      return categories[i].name;
    }
  }
};
/**
 * @param offers
 * @return {*}
 */
export default function prepareOffers(offers) {
  const prepared_offers = [];
  let offer_name;
  for (offer_name in offers) {
    if (offers.hasOwnProperty(offer_name)) {
      const offer = Object.assign(offers[offer_name]);
      if (env.isMyGames()) {
        offer.service_id = mycom_real_orders[offer_name];
      }
      offer.category = getCategory(offer_name);
      prepared_offers.push(offer);
    }
  }
  return prepared_offers.sort((offer1, offer2) => offer1.cost_usd - offer2.cost_usd);
}
